// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  applicationKey: 'tyu',
  apiUrl: 'https://test-1api.ignatius.io',
  // When developing locally, use the dev-server proxy by keeping apiUrl empty
  // and mapping '/api' to the remote in proxy.conf.json and add the following to the angular.json after line:
  //"browserTarget": "ignatius:build",
  //"proxyConfig": "proxy.conf.json"
  //apiUrl: '',
  //test ai url
  // aiApiUrl: 'https://workflowv1.ignatius.io/webhook-test/84b9f009-6e01-4a53-bba9-60ad36b466a0',
  //live ai url
  aiApiUrl: 'https://workflowv1.ignatius.io/webhook/84b9f009-6e01-4a53-bba9-60ad36b466a0',
  // apiUrl: 'http://localhost:50731',
  mlBaseUrl: 'https://ml.ignatius.io',
  domain: 'test-1.ignatius.io',
  secretKey: 'x/A?D*G-KaPdSgVkYp3s6v9y$B&E)H+M',
  //localhost flexKey
  //flexKey:'Z7EZ-14486J-2C1809-052626-1X091L-034U0R-0Y3R3C-5S3I2R-3K5Z3S-5N644E-0E5M52-1D5466-020V5T-444O51-2A711I-6L1E4M-154D54-5Y132L-2Y',
  //dev.ignatius.io flexKey -perpetual
  //flexKey: 'Z7N1-XHD155-542O13-5Q3I6S-5Z0A05-4X1121-0U4L40-4I1C5R-2T0G6O-3A4X',
  //saas key
  flexKey: ['Z7QF-XI3C5K-2O2W4Q-0U5343-0C1Q4K-5C0R23-0I5P0W-4P5M0W-3R642X-5I3K58', 'Z7EN-XG193B-030W3Z-10671O-604U1H-6B2K1Z-5H5M5E-4X0B50-6W0H', 'Z7ID-XJ6102-574Z6Z-4A4T2X-403J44-4Y5L15-5W4L3B-2I3T5L-2Z5G2N-5I081I-2X2L3H-12', 'Z7Q2-XJ311R-375T0H-0W0M3F-2A3Y2F-0J6W28-6F4F5P-5M5A21-706759-354Z6P'],
  flexDataLimit: 20000, //20K
  clientId: 'IAFConsulting',
  mapBoxToken:
    'pk.eyJ1IjoiaWFmY29uc3VsdCIsImEiOiJja2UzcHh0bXAwZnRpMndxaDQ1Zmp3NWV4In0.P-7egsjZgUlgYjWKF8VhIA',
  captchaSiteKey: '6Lc2Z7UdAAAAAL8HwkjdbWS1OsNKBv2aUvlN1clV',
  captchaSiteKeyV2: '6LftwGwaAAAAAIjIRFgI-UuqjtuaUJ3LXBFXTNBj',
  workflowUrl: 'https://test-1workflow.ignatius.io',
  // supersetUrl:'http://localhost:9000'
  supersetUrl:'https://analyticsv1.ignatius.io',
  Auth0Domain: 'https://gab-legacy.us.auth0.com',
  Auth0ClientId: 'ckmT7CCOU9OmUfxcBMYsb3sheRwy2i0g',
  Auth0Audience: 'https://test-1api.ignatius.io',
  OGAuth0Domain: 'https://login.ogintegration.us',
  OGAuth0ClientId: '5pZXGyFrbWmBCu2wejF2cf28iVz1itse',
  OGAuth0Audience: 'https://test-1api.ignatius.io',
  useExternalLoginProvider: true,
  launchDarkly: {
    clientSideId: '68a4c9c6a676d0098c4ca84e'
  },
  gabImportHealthUrl: 'https://api.gabimport.ogintegration.us/health',
  controlPanelURL: 'https://controlpanel.ogintegration.us',
  importApiUrl: 'https://api.gabimport.ogintegration.us',
  importProxyUrl: 'https://gab-opengov-proxy.opengov.workers.dev',
  gabImportBaseUrl: 'https://api.gabimport.ogintegration.us',
  gabImportApiVersion: '/api/v1',
  ogInsightsUrl: 'https://gab-analytics.integration.opengov.zone'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
